import React, { FC } from 'react'
import { IonModal, IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import { memberMobx } from '@mobxStore'
import { MktButton } from '@cps'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  reject: () => void;
  resolve: (type: string) => void;
}
const VerificationType: FC<IProps> = (props) => {
  const { reject, resolve } = props
  const { memberInfo } = memberMobx
  const { mobile, email } = memberInfo

  const handleBinding = (type: string) => {
    resolve(type)
  }
  return (
    <IonModal
      cssClass='verification-type-modal'
      isOpen
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span className='title'>{i18n.t('mkt.common.chooseVerMethod')}</span>
        <div className='right' onClick={reject}>
          <i className='iconfont icon-close'></i>
        </div>
      </IonHeader>
      <div className='modal-content'>
        {
          mobile &&
            <div className='btn-area'>
              <MktButton text={i18n.t('mkt.common.mobile')} onClick={() => handleBinding('mobile')}></MktButton>
            </div>
        }
        {
          email &&
            <div className='btn-area'>
              <MktButton text={i18n.t('mkt.common.email')} className='email-btn' onClick={() => handleBinding('email')}></MktButton>
            </div>
        }
      </div>
    </IonModal>
  )
}

export default observer(VerificationType)
